var map = {
	"./icon-math.png": 64,
	"./icon-projection.png": 65,
	"./icon-risk.png": 66,
	"./icon-studies.png": 67
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*$
// module id = 15
// module chunks = 0